import React from 'react';
import { List, Empty, Typography, Card } from 'antd';
import TaskItem from './TaskItem';

const { Text } = Typography;

const TaskList = ({ tasks, selectedStatus, onRefresh }) => {
  if (!tasks || tasks.length === 0) {
    const emptyMessages = {
      all: 'No tasks found',
      active: 'No active tasks running',
      waiting: 'No tasks waiting in queue',
      completed: 'No completed tasks',
      failed: 'No failed tasks'
    };

    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        height: 300,
        padding: 24,
        borderRadius: 8,
        margin: 16
      }}>
        <Empty 
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <div style={{ textAlign: 'center' }}>
              <Text type="secondary" style={{ fontSize: 14, fontWeight: 500 }}>
                {emptyMessages[selectedStatus]}
              </Text>
              <br />
              <Text type="secondary" style={{ fontSize: 12, opacity: 0.7 }}>
                Tasks will appear here when they are created
              </Text>
            </div>
          }
        />
      </div>
    );
  }

  return (
    <div style={{ 
      height: '100%', 
      overflow: 'auto',
      background: '#f8f9fa',
      padding: '12px 16px'
    }}>
      <List
        itemLayout="vertical"
        size="small"
        dataSource={tasks}
        renderItem={(task, index) => (
          <Card
            key={task.id}
            size="small"
            style={{
              marginBottom: 8,
              borderRadius: 8,
              boxShadow: '0 2px 4px rgba(0,0,0,0.06)',
              border: '1px solid #e8e8e8',
              background: '#fff',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            bodyStyle={{ 
              padding: '12px 16px',
              borderRadius: 8
            }}
            hoverable
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.borderColor = '#40a9ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.06)';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = '#e8e8e8';
            }}
          >
            <TaskItem 
              task={task} 
              index={index}
              onRefresh={onRefresh}
            />
          </Card>
        )}
        style={{ padding: 0 }}
      />
    </div>
  );
};

export default TaskList;
